import { render, staticRenderFns } from "./simulation.vue?vue&type=template&id=52a58375&scoped=true"
import script from "./simulation.vue?vue&type=script&lang=js"
export * from "./simulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a58375",
  null
  
)

export default component.exports